import type { SolarModule } from '../types';

// ============================================================
// EQUIPMENT DATABASE — Hardcoded for MVP
// In production this would come from an API or database
// ============================================================

export const MODULES: Record<string, SolarModule> = {
  rec400: {
    id: 'rec400',
    manufacturer: 'REC',
    model: 'Alpha 400',
    wattage: 400,
    efficiency: 21.7,
    length: 1.82,
    width: 1.02,
  },
  qcells410: {
    id: 'qcells410',
    manufacturer: 'Q CELLS',
    model: 'Q.PEAK DUO 410',
    wattage: 410,
    efficiency: 20.3,
    length: 1.84,
    width: 1.04,
  },
  sunpower410: {
    id: 'sunpower410',
    manufacturer: 'SunPower',
    model: 'A-410',
    wattage: 410,
    efficiency: 22.2,
    length: 1.69,
    width: 1.05,
  },
  lg420: {
    id: 'lg420',
    manufacturer: 'LG',
    model: 'NeON H 420',
    wattage: 420,
    efficiency: 21.1,
    length: 1.86,
    width: 1.05,
  },
  canadian405: {
    id: 'canadian405',
    manufacturer: 'Canadian Solar',
    model: 'HiKu6 405',
    wattage: 405,
    efficiency: 20.4,
    length: 1.82,
    width: 1.05,
  },
};

export const MODULE_OPTIONS = Object.values(MODULES);
export const DEFAULT_MODULE = MODULES.rec400;
